import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        // 401 on api/ requests redirects to MVC logout (see handleUnauthorized401) before guards run.
        provideHttpClient(withInterceptors([authInterceptor])),
        // Bootstrap waits for loadUser so UserStore.user is set before routing.
        provideAppInitializer(() => inject(AuthService).authenticate()),
    ];
};
